import { Injectable } from '@angular/core';
import { BsDatepickerConfig } from './bs-datepicker.config';

@Injectable()
export class BsDatepickerInlineConfig extends BsDatepickerConfig { }
